<template>
    <div
        class="form-error"
        :class="{ 'is-large': size === 'large' }"
    >
        <a-glyph
            v-if="showIcon"
            class="form-error__icon"
            name="i-times-circle--16"
        />
        <slot />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import AGlyph from '@core/components/glyph/glyph.vue';

export default defineComponent({
    name: 'ElFormError',
    components: {
        AGlyph,
    },
    props: {
        showIcon: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'small',
        },
    },
});
</script>
